<template>
  <div class="appBody bg-white pb-5 position-relative">
    <little-header></little-header>
    <p class="text-center mb-0 mt-3 font-18">收银台</p>
    <div class="d-flex flex-column align-items-center mt-4 pb-3 border-bottom">
      <p class="mb-0 text-primary font-weight-bold font-24  line-24">
        <span class="font-15">¥</span>{{curOrderObj.unpaidAmount}}
      </p>
      <p class="mt-3 mb-0 pay-time color-66 font-13" v-if="leftTime>0">
        支付剩余时间{{leftTimeStr}}
      </p>
      <p class="mt-3 mb-0 pay-time color-66 font-13" v-else>
        订单超时，请重新下单
      </p>
      <p class="my-3 d-flex color-66 font-13 cursor-pointer">
        订单号：{{curOrderObj.id}}
        <span class="copy-btn font-10 color-66" @click="copyFunc">复制</span>
      </p>
      <div class="pay-list">
        <div class="list">
          <p class="pb-3 mb-0 font-15 color-0d">支付方式</p>
          <van-radio-group v-model="payType">
            <van-cell-group>
              <!--              <van-cell class="border-top text-black" clickable @click="radio = '3'">-->
              <!--                <template #title>-->
              <!--                  <img class="mr-3 img-icon" src="/static/img/pro/dd5.png">余额支付-->
              <!--                </template>-->
              <!--                <template #right-icon>-->
              <!--                  <van-radio name="1"/>-->
              <!--                </template>-->
              <!--              </van-cell>-->
              <van-cell class=" border-top text-black" clickable @click="payType = 'wxpay'">
                <template #title>
                  <img class="mr-3 img-icon" src="/static/img/pro/pay/wechat_pay_64.png">微信支付
                </template>
                <template #right-icon>
                  <van-radio name="wxpay"/>
                </template>
              </van-cell>
              <van-cell class="border-top text-black" clickable @click="payType = 'alipay'">
                <template #title>
                  <img class="mr-3 img-icon" src="/static/img/pro/pay/alipay_64.png">支付宝支付
                </template>
                <template #right-icon>
                  <van-radio name="alipay"/>
                </template>
              </van-cell>
            </van-cell-group>
          </van-radio-group>
        </div>
        <van-field class="agreement mb-0 py-0 overflow-hidden" name="agree"
                   :rules="[{ required: true, message: '同意报名退费协议'}]">
          <template #input>
            <van-checkbox class="mr-1" v-model="agreement"></van-checkbox>
            <div class="cursor-pointer" @click="getAgreementContent">同意报名退费协议</div>
          </template>
        </van-field>

        <van-popup v-if="!loading" class="pop max-w-640 m-auto" v-model="showAgreement" round position="bottom"
                   closeable close-icon="close " :style="{ height: '70%' }">
          <div class="text-center font-weight-bold">
            退费协议
          </div>
          <div v-if="content.content" v-html="contentHtml"></div>
          <div class="d-flex cursor-pointer justify-content-center align-items-center font-weight-bold my-3 font-15"
               @click="showAgreement=false">
            <img class="mr-1 agreementImg" src="/static/img/pro/agreen.png"/> 我已阅读
          </div>
        </van-popup>
      </div>
    </div>
    <div class="sub-btn mx-3">
      <van-button class="w-100 mt-5 font-16" :disabled="isDisabledSubmitBtn||!agreement||!payType" round block
                  type="info"
                  @click="submitPay">
        {{payType==='wxpay'?'微信':payType==='alipay'?'支付宝':''}}支付 <span class="mr-1">¥</span>{{curOrderObj.unpaidAmount}}
      </van-button>
    </div>

    <van-overlay :show="isPcCode && payType==='wxpay'" @click="closeCode">
      <div class="payQrcode position-absolute" v-if="isPcCode">
        <div class="payQrcode-div d-flex flex-column " :class="{'bg-white': hadCode, 'bg-transparent': !hadCode}">
          <div ref="payQrcode" id="payQrcode" class="payQrcodeImg"></div>
          <p v-if="hadCode" class="WechatQr_label_2LlA1">使用微信扫码支付</p>
        </div>
      </div>
    </van-overlay>
    <div v-if="payType==='alipay'" v-html="aliPayHtml"></div>

  </div>
</template>

<script>
  import urlencode from "urlencode";
  import LittleHeader from "@/components/littleHeader";
  import Vue from 'vue';
  import {
    NavBar,
    Button,
    Icon,
    RadioGroup,
    Radio,
    Cell,
    CellGroup,
    Field,
    Checkbox,
    Overlay,
    Dialog,
    Popup
  } from 'vant';
  import QRCode from 'qrcodejs2'
  import {mapState} from "vuex";

  Vue.use(Radio);
  Vue.use(RadioGroup);
  Vue.use(Button);
  Vue.use(NavBar);
  Vue.use(Icon);
  Vue.use(Cell);
  Vue.use(CellGroup);
  Vue.use(Field);
  Vue.use(Checkbox);
  Vue.use(Overlay);
  Vue.use(Dialog);
  Vue.use(Popup);
  export default {
    name: "payPage",
    data() {
      return {
        id: '',
        orderId: '',
        radio: 0,
        radio1: 0,
        isAlipay: false,
        isWechat: false,
        payType: '',
        amount: 0,
        balance: 0,
        agreement: '',// 同意agree，不同意空
        transactionId: '',
        leftTime: 0,
        serverCurrentTime: 0,
        leftTimeStr: '',
        countdownTimer: 0,
        orderTimer: 0,
        leftTimer: 0,
        curOrderObj: {},
        orderBody: {},
        isPcCode: false,
        hadCode: false,
        isDisabledSubmitBtn: false,
        loading: false,
        showAgreement: false,
        contentHtml: {},
        content: {},
        aliPayHtml: '',
      }
    },
    destroyed() {
      // 清除轮询
      clearInterval(this.leftTimer);
      this.leftTimer = null;
      // clearInterval(this.orderTimer)
      // this.orderTimer = null;
    },
    components: {
      LittleHeader,
    },
    computed: {
      ...mapState({
        param: state => state.page
      })
    },
    created() {
      this.orderId = this.$route.params['id'];
      let u = navigator.userAgent;
      let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      if (this.$route.query['tranId'] && isiOS) {
        this.transactionId = this.$route.query['tranId'];
        this.queryIsPay();
      }
    },
    mounted() {
      this.loadData();
      this.getServerCurrentTime();
    },

    methods: {
      getServerCurrentTime() {
        this.$store.dispatch('getServerCurrentTimeUrl', {}).then((time) => {
          this.serverCurrentTime = parseInt(time.data);
        },(error) => {
          let now = new Date().getTime();
          this.serverCurrentTime = now;
        })
      },
      loadData() {
        this.$store.dispatch('getOrderById', {id: this.orderId}).then((res) => {
          if (res) {
            this.curOrderObj = res;
            this.leftTime = this.curOrderObj.expireTime - this.serverCurrentTime;
            this.leftTimeStr = this.getTimeLeftStrOrder(this.leftTime);
            this.amount = this.curOrderObj.unpaidAmount;
            let _this = this;
            this.leftTimer = setInterval(() => {
              if (_this.leftTime > 0) {
                this.leftTimeStr = this.getTimeLeftStrOrder(this.leftTime);
                _this.leftTime -= 1000;
              } else {
                Dialog.alert({
                  title: '信息',
                  message: '订单超时，请重新下单？',
                  confirmButtonText: '重新选课',
                }).then(() => {
                  //重新选课
                  this.$router.push('/recommend-project/' + this.curOrderObj.merchantId);
                });
                clearInterval(this.leftTimer);
                clearInterval(this.orderTimer);
                this.orderTimer = null;
              }
            }, 1000);
          }
        })
      },
      // 关闭弹框,清除已经生成的二维码
      closeCode() {
        this.isPcCode = false;
        this.$refs.payQrcode.innerHTML = "";
        // 清除轮询
        clearInterval(this.orderTimer);
        this.orderTimer = null;
        this.hadCode = false;
        this.isDisabledSubmitBtn = false;
      },

      getAgreementContent() {
        this.showAgreement = true;
        this.getContentInfo();
      },
      getContentInfo() {
        this.loading = true;
        this.param.categoryId = 'static_refund';
        this.param.count = false;
        this.param.defaultCount = true;
        this.$store.dispatch('searchContentPublished', this.param).then((result) => {
          if (result.list && result.list.length > 0) {
            this.content = result.list[0];
            if (this.content.content) {
              this.$store.dispatch('getContent', {content: this.content.content}).then((result) => {
                this.loading = false;
                this.contentHtml = result;
              })
            }
          }
        })
      },
      submitPay() {
        if (window.navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) {
          //移动端
          if (this.payType === 'wxpay') {
            this.wxPay('WXPAY_MWEB');
          } else if (this.payType === 'alipay') {
            this.wxPay('ALIPAY_WAP')
          }
        } else {
          //pc端页面
          this.isPcCode = true;
          if (this.payType === 'wxpay') {
            this.wxPay('WXPAY_NATIVE')
          } else if (this.payType === 'alipay') {
            this.wxPay('ALIPAY_PC')
          }
        }

      },
      wxPay(type) {
        this.isDisabledSubmitBtn = true;  //防止用户点击多次
        this.$store.dispatch('getTradeTransactionUrl', {
          orderId: this.curOrderObj.id,
          params: {
            payTypeName: type,
            step: this.curOrderObj.currentStep,
            balance: 0,
            money: this.curOrderObj.amount,
            tradeFrom: 'H5'
          }
        }).then(res => {
          if (res) {
            this.transactionId = res.transactionId;
            this.orderBody = res.body;
            if (this.payType === 'wxpay') {
              this.orderTimer = setInterval(() => {
                this.queryIsPay();
              }, 3000);
              if (this.isPcCode) {
                //生成微信支付二维码
                this.drawCode(this.orderBody);
              } else {
                let u = navigator.userAgent;
                let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
                if (isiOS) {
                  let url = urlencode('https://m.aqjsjx.com.cn/pay/' + this.curOrderObj.id + '?tranId=' + this.transactionId);
                  location.href = this.orderBody + '&redirect_url=' + url;
                } else {
                  location.href = this.orderBody;
                }
              }
            } else {
              if (this.isPcCode) {
                this.aliPayHtml = this.orderBody;
              } else {
                //移动端支付宝支付
                this.aliPayHtml = this.orderBody;
              }
              this.$nextTick(() => {
                document.forms[0].submit()
              })
            }

          }
        })
      },
      queryIsPay() {
        this.$store.dispatch('getTransactionById', {id: this.transactionId, type: 'noLoading'}).then((res) => {
          if (res && res.status === 'success') {
            clearInterval(this.orderTimer);
            this.orderTimer = null;
            this.$toast({
              message: "支付成功",
              duration: 2000
            });
            setTimeout(() => {
              localStorage.removeItem('selectedObj');
              this.$router.push({name: 'indexProject', params: {id: this.curOrderObj.merchantId}})
            }, 2000)
          } else {
            return false;
          }
        }).catch(err => {
          return false
        })
      },

      // 绘制二维码
      drawCode(codeUrl) {
        this.$nextTick(() => {
          new QRCode(this.$refs.payQrcode, {
            width: 240,
            height: 240,
            text: codeUrl, // 二维码地址
            colorDark: '#000',
            colorLight: '#fff'
          });
          this.hadCode = true;
        })
      },
      copyFunc() {
        let oInput = document.createElement("input");
        oInput.value = this.orderId;
        document.body.appendChild(oInput);
        oInput.select(); // 选择对象
        document.execCommand("Copy"); // 执行浏览器复制命令
        oInput.className = "oInput";
        oInput.style.display = "none";
        this.$toast({
          message: "复制成功!",
          type: 'success'
        })
      },
      getTimeLeftStrOrder(value) {
        let visitTime = '';
        let leftTime = value;
        let func = function checTime(i) {
          return i < 10 ? "0" + i : i + "";
        };
        let d = parseInt(leftTime / (1000 * 24 * 60 * 60));
        let h = parseInt(leftTime / (1000 * 60 * 60) % 24);
        let m = parseInt(leftTime / (1000 * 60) % 60);
        let s = parseInt(leftTime / 1000 % 60);

        let days = func(d);
        let hours = func(h);
        let minutes = func(m);
        let seconds = func(s);

        if (days > 0) {
          visitTime = days + '天' + hours + '小时';
        } else if (hours > 0) {
          visitTime = hours + '小时' + minutes + '分';
        } else if (minutes > 0) {
          visitTime = minutes + '分' + seconds + '秒';
        } else if (seconds > 0) {
          visitTime = seconds + '秒';
        }
        return visitTime;
      },
    }
  }
</script>

<style scoped lang="scss">
  $browser-default-font-size: 16px !default;
  @function pxTorem($px) {
    @return $px / $browser-default-font-size * 1rem;
  }

  .pop {
    padding: pxTorem(24px);
  }

  .payQrcode {
    display: flex;
    justify-content: center;
    align-items: center;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background-color: #00000099;
    z-index: 10001;

    .payQrcode-div {
      position: relative;
      z-index: 20000;
      top: -50px;
      background-color: white;
      padding: 15px 15px 5px;
      border-radius: 10px;
    }

    .WechatQr_label_2LlA1 {
      margin-top: 10px;
      margin-bottom: 0;
      text-align: center;
      line-height: 32px;
      font-size: 16px;
      font-weight: 400;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
    }
  }

  .agreementImg {
    width: pxTorem(15px);
  }

  .pay-time {
    padding: pxTorem(4px) pxTorem(10px) pxTorem(4px) pxTorem(10px);
    border: 1px solid #eeeeee;
    border-radius: pxTorem(20px);
  }

  .copy-btn {
    margin-left: pxTorem(20px);
    border: 1px solid #eeeeee;
    border-radius: pxTorem(16px);
    padding: pxTorem(0px) pxTorem(10px) pxTorem(0px) pxTorem(10px);
  }

  .pay-list {
    width: 100%;

    .list {
      margin: pxTorem(24px) pxTorem(24px) pxTorem(0px) pxTorem(24px);
      box-shadow: 1px 1px 1px #eeeeee;
      border-radius: pxTorem(4px);
      padding: pxTorem(8px) pxTorem(20px) pxTorem(16px) pxTorem(20px);

      .van-cell {
        padding: pxTorem(16px) pxTorem(0px) pxTorem(16px) pxTorem(0px);
      }
    }

    .agreement {
      margin-top: pxTorem(16px);
      padding: pxTorem(8px) pxTorem(44px) pxTorem(8px) pxTorem(44px);
    }

    .img-icon {
      width: pxTorem(26px);
    }

  }

  .pay_btn {
    text-align: center;

    p {
      width: 100%;
      margin-top: 1rem;
      padding: pxTorem(8px) pxTorem(20px) pxTorem(8px) pxTorem(20px);
      border-radius: pxTorem(20px);
      color: white;
      font-size: pxTorem(15px);
    }
  }

  .sub-btn {
    .van-button--normal {
      font-size: pxTorem(16px);
    }
  }

</style>
